import Scrollbar from './src/main';

export default Scrollbar;
